import { useEffect, useState } from 'react';
import { CMS_IFRAME_READY, isCmsHostAuthMessage, parseCmsHostAuthMessage, } from './messages';
export function useIframeHostAuth() {
    const [auth, setAuth] = useState(null);
    const [status, setStatus] = useState('waiting');
    const [error, setError] = useState(null);
    useEffect(() => {
        let readyInterval;
        const notifyParent = () => {
            if (window.parent === window) {
                return;
            }
            window.parent.postMessage({ type: CMS_IFRAME_READY }, '*');
        };
        const onMessage = (event) => {
            if (!isCmsHostAuthMessage(event.data)) {
                return;
            }
            setAuth(parseCmsHostAuthMessage(event.data));
            setError(null);
            setStatus('ready');
            if (readyInterval) {
                clearInterval(readyInterval);
                readyInterval = undefined;
            }
        };
        notifyParent();
        readyInterval = setInterval(notifyParent, 2000);
        window.addEventListener('message', onMessage);
        return () => {
            window.removeEventListener('message', onMessage);
            if (readyInterval) {
                clearInterval(readyInterval);
            }
        };
    }, []);
    return { auth, status, error };
}
